/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon24Solid = forwardRef('FoodWareDishIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.25 6.684a2.624 2.624 0 1 0-2.5 0v1.402a9.004 9.004 0 0 0-7.695 7.916c-.06.549.393.998.945.998h16c.552 0 1.006-.45.945-.998a9.005 9.005 0 0 0-7.695-7.916V6.684Z" }),
        React.createElement("path", { d: "M2 18.25a1.25 1.25 0 1 0 0 2.5h20a1.25 1.25 0 1 0 0-2.5H2Z" })));
});
